import { IShop } from "models/contracts/shop";

const queueLabels: Record<string, string> = {
    showDeliveryQueue: "Delivery",
    showSpecialQueue: "Special",
    showWalkInQueue: "Walking",
    showOnlineQueue: "Online",
};

const order = [
    "showDeliveryQueue",
    "showOnlineQueue",
    "showSpecialQueue",
    "showWalkInQueue",
] as const;

export const getEnabledQueues = (shop: IShop) => {
    return order
        .filter((key) => shop[key])
        .map((key) => queueLabels[key])
        .join(", ");
}


// WEBPACK FOOTER //
// ./src/utils/shopUtils.ts